<section>
  <div class=" innerContainer text_center">
    <h2 class="vc-title-m affiliation_title" i18n="@@AFFILIATION.TITLE">
      Affiliate Program
    </h2>
    <p class="affiliation_chapeau affiliation_intro" i18n="@@AFFILIATION.HAT">
      Join Vestiaire collective's Affliliate Marketing Program!<br />
      Earn commision every time your visitors buy from Vestiaire Collective
    </p>
  </div>
</section>
<section class="banner_joinUs innerContainer">
  <div class="banner_joinUs_module text-center">
    <div>
      <vc-icons class="world-icon" name="#world"> </vc-icons>
      <p class="textProgram" i18n="@@AFFILIATION.PROGRAM">
        Program available globaly
      </p>
    </div>
    <div>
      <span>with:</span>
      <img
        class="affiliation__affiliate__image"
        alt="affiliate"
        [src]="'/assets/images/affiliatePage/affiliate_logo.png' | vcimage: baseImgxAttrs:true:overrideImgxUrl"
      />
    </div>
    <div>
      <vc-ref [blank]="true" class="joinUs_btn" resource="https://signup.cj.com/member/signup/publisher/?cid=5220338">
        <span i18n="@@AFFILIATION.JOINUS" class="vc-btn vc-btn--primary vc-btn--medium vc-btn--full">
          Join us todays
        </span>
      </vc-ref>
    </div>
  </div>
</section>
<section class="innerContainer benefits">
  <div class="module_benefits">
    <h3 class="vc-title-xs affiliation_title" i18n="@@AFFILIATION.TITLE_SECTION1">
      Member benefits:
    </h3>
    <ul class="benefits_list">
      <div>
        <li i18n="@@AFFILIATION.BENEFIT1">
          Up to 10% commision on net safes
        </li>
        <li i18n="@@AFFILIATION.BENEFIT2">
          Lowest return rate in the market
        </li>
        <li i18n="@@AFFILIATION.BENEFIT3">
          15 days cookie window
        </li>
      </div>
      <div>
        <li i18n="@@AFFILIATION.BENEFIT4">
          Real-time reporting and sales tracking
        </li>
        <li i18n="@@AFFILIATION.BENEFIT5">
          Daily updated product feeds
        </li>
      </div>
      <div>
        <li i18n="@@AFFILIATION.BENEFIT6">
          Editorial publisher newsletter
        </li>
        <li i18n="@@AFFILIATION.BENEFIT7">
          AOV of €500 under affiliate program
        </li>
      </div>
    </ul>
  </div>
</section>
<section class="innerContainer">
  <div class="module_img_text">
    <div class="img_container">
      <img
        class="affiliation__affiliate__image image_left"
        alt="affiliate"
        [src]="'/assets/images/affiliatePage/Image1.jpg' | vcimage: affiliateImgxAttrs:true:overrideImgxUrl"
      />
    </div>
    <div class="text_container">
      <div>
        <h3 class="vc-title-s affiliation_title_section" i18n="@@AFFILIATION.TITLE_SECTION2">
          What do affliates do?
        </h3>
        <p class="main-text" i18n="@@AFFILIATION.TEXT_SECTION2">
          As a member of our affliate network, your tasks will include :
        </p>
        <ul>
          <li i18n="@@AFFILIATION.INCLUDE1">
            Promoting Vestiaire Collective through banners, affliate links and advertisings on your site.
          </li>
          <li i18n="@@AFFILIATION.INCLUDE2">
            Using our product data feed to promote our latest pre-loved fashion items to your visitors.
          </li>
          <li i18n="@@AFFILIATION.INCLUDE3">
            Informing your visitors about our new arrivals and must-have items
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
<section class="innerContainer process">
  <div class="module_process">
    <h3 class="vc-title-s affiliation_title text_center" i18n="@@AFFILIATION.TITLE_SECTION3">
      The Process
    </h3>
    <ul class="process_list">
      <li>
        <div class="process_puce">
          <span class="process_number">1</span>
        </div>
        <p i18n="@@AFFILIATION.PROCESS1">
          Apply directly to the Vestaire Collective Program via CJ Affiliate, or contact
          <a href="mailto:affiliates@vestiairecollective.com">affiliates@vestiairecollective.com</a>
        </p>
      </li>
      <li>
        <div class="process_puce">
          <span class="process_number">2</span>
        </div>
        <p i18n="@@AFFILIATION.PROCESS2">
          We will review your application and come back to you within some days if your site is aligned with Vestaire
          Collective's point of view.
        </p>
      </li>
      <li>
        <vc-ref [blank]="true" class="joinUs_btn" resource="https://signup.cj.com/member/signup/publisher/?cid=5220338">
          <span i18n="@@AFFILIATION.JOINUS" class="vc-btn vc-btn--primary vc-btn--medium vc-btn--full">
            Apply now
          </span>
        </vc-ref>
      </li>
    </ul>
  </div>
</section>
<section class="innerContainer partners">
  <div class="module_partners">
    <div class="banner_partners">
      <h3 class="vc-title-s affiliation_title" i18n="@@AFFILIATION.TITLE_SECTION4">
        Our Partners
      </h3>
      <div class="logo_partners">
        <img alt="Lyst" [src]="'/assets/images/affiliatePage/Lyst.png' | vcimage: baseImgxAttrs:true:overrideImgxUrl" />
        <img
          alt="RewardStyle"
          [src]="'/assets/images/affiliatePage/rewardStyle_Logo.png' | vcimage: baseImgxAttrs:true:overrideImgxUrl"
        />
        <img
          alt="Fashiola"
          [src]="'/assets/images/affiliatePage/Fashiola.png' | vcimage: baseImgxAttrs:true:overrideImgxUrl"
        />
        <img
          alt="Shopstyle"
          [src]="'/assets/images/affiliatePage/Shopstyle.png' | vcimage: baseImgxAttrs:true:overrideImgxUrl"
        />
      </div>
    </div>
  </div>
</section>
<section class="innerContainer">
  <div class="module_img_text text_img">
    <div class="img_container">
      <img
        class="affiliation__affiliate__image image_right"
        alt="affiliate"
        [src]="'/assets/images/affiliatePage/Image2.jpg' | vcimage: affiliateImgxAttrs:true:overrideImgxUrl"
      />
    </div>
    <div class="text_container">
      <div>
        <h3 class="vc-title-s affiliation_title_section" i18n="@@AFFILIATION.TITLE_SECTION5">
          Who are we?
        </h3>
        <p class="main-text" i18n="@@AFFILIATION.TEXT_SECTION5">
          Considering the luxury resale business is growing four times faster than traditional luxury, our community is
          expanding really fast! Today, over 8 million fashion lovers use our community to buy, sell and share curated
          items from high-end brands.
          <br /><br />
          Vestiaire Collective differs by its quality, with a whole team dedicated to quality control to ensure the
          authenticity and conformity of each product, as well as a moderation team, responsible for making a thorough
          and relevant selection.
        </p>
      </div>
    </div>
  </div>

  <div class="btn_container">
    <vc-ref [blank]="true" class="joinUs_btn" resource="https://signup.cj.com/member/signup/publisher/?cid=5220338">
      <span i18n="@@AFFILIATION.JOINUS" class="vc-btn vc-btn--primary vc-btn--medium vc-btn--full">
        Join us todays
      </span>
    </vc-ref>
  </div>

  <div class="banner_information text_center">
    <p i18n="@@AFFILIATION.MORE_INFO">
      For more information:
      <a class="banner_information_link" href="mailto:affiliates@vestiairecollective.com">
        affiliates@vestiairecollective.com
      </a>
    </p>
  </div>
</section>
